import { defineMessages } from 'react-intl-next';

export const addFieldMenuMessages = defineMessages({
  searchPlaceholder: {
    id: 'field-type.add-field-menu.search-placeholder',
    defaultMessage: 'Search fields',
    description: 'Search input placeholder for filtering options in the add field menu.'
  },
  aiFieldsSection: {
    id: 'field-type.add-field-menu.ai-fields-section',
    defaultMessage: 'AI fields',
    description: 'Section title for AI field type options in the add field menu.'
  },
  basicFieldTypesSection: {
    id: 'field-type.add-field-menu.basic-field-types-section',
    defaultMessage: 'Basic fields',
    description: 'Section title for basic field type options in the add field menu.'
  },
  aiSummary: {
    id: 'field-type.add-field-menu.ai-summary',
    defaultMessage: 'Summary',
    description: 'Menu item label for creating an AI summary field.'
  },
  aiSummaryTooltip: {
    id: 'field-type.add-field-menu.ai-summary-tooltip',
    defaultMessage: 'Add an AI-generated summary of a given entry',
    description: 'Tooltip for the AI summary field type option in the add field menu.'
  },
  advancedFieldTypesSection: {
    id: 'field-type.add-field-menu.advanced-field-types-section',
    defaultMessage: 'Advanced fields',
    description: 'Section title for advanced field type options in the add field menu.'
  },
  confluenceSection: {
    id: 'field-type.add-field-menu.confluence-section',
    defaultMessage: 'Confluence',
    description: 'Collapsed section label for Confluence field type options.'
  },
  confluenceLink: {
    id: 'field-type.add-field-menu.confluence-link',
    defaultMessage: 'Confluence link',
    description: 'Short label for the Confluence link field type option.'
  },
  confluenceMoreDetails: {
    id: 'field-type.add-field-menu.confluence-more-details',
    defaultMessage: 'More details',
    description: 'Short label for the Confluence more details field type option.'
  },
  confluenceEntryLink: {
    id: 'field-type.add-field-menu.confluence-entry-link',
    defaultMessage: 'Entry link',
    description: 'Short label for the Confluence entry link field type option.'
  },
  entryDetail: {
    id: 'field-type.add-field-menu.entry-detail',
    defaultMessage: 'Entry detail',
    description: 'Short label for the entry detail field type option.'
  },
  jiraLink: {
    id: 'field-type.add-field-menu.jira-link',
    defaultMessage: 'Jira link',
    description: 'Short label for the Jira link field type option.'
  },
  jiraDetail: {
    id: 'field-type.add-field-menu.jira-detail',
    defaultMessage: 'Jira detail',
    description: 'Short label for the Jira detail field type option.'
  },
  link: {
    id: 'field-type.add-field-menu.link',
    defaultMessage: 'Link',
    description: 'Short label for the link field type option.'
  },
  description: {
    id: 'field-type.add-field-menu.description',
    defaultMessage: 'Description',
    description: 'Short label for description field type options.'
  },
  textTooltip: {
    id: 'field-type.add-field-menu.text-tooltip',
    defaultMessage: 'Add simple text',
    description: 'Tooltip for the text field type option in the add field menu.'
  },
  checkboxTooltip: {
    id: 'field-type.add-field-menu.checkbox-tooltip',
    defaultMessage: 'Use a checkbox to mark something complete, active, or true.',
    description: 'Tooltip for the checkbox field type option in the add field menu.'
  },
  mediaAndFilesTooltip: {
    id: 'field-type.add-field-menu.media-and-files-tooltip',
    defaultMessage: 'Add visual assets or files',
    description:
      'Tooltip for the media and files field type option in the add field menu.'
  },
  numberTooltip: {
    id: 'field-type.add-field-menu.number-tooltip',
    defaultMessage: 'Display a numerical, percentage, or currency value',
    description: 'Tooltip for the number field type option in the add field menu.'
  },
  dateTooltip: {
    id: 'field-type.add-field-menu.date-tooltip',
    defaultMessage: 'Display a formatted date',
    description: 'Tooltip for the date field type option in the add field menu.'
  },
  tagTooltip: {
    id: 'field-type.add-field-menu.tag-tooltip',
    defaultMessage: 'Create tags for categorization',
    description: 'Tooltip for the tag field type option in the add field menu.'
  },
  userTooltip: {
    id: 'field-type.add-field-menu.user-tooltip',
    defaultMessage: 'Tag users in your organization',
    description: 'Tooltip for the user field type option in the add field menu.'
  },
  urlTooltip: {
    id: 'field-type.add-field-menu.url-tooltip',
    defaultMessage: 'Include links or URLs',
    description: 'Tooltip for the URL field type option in the add field menu.'
  },
  confluenceLinkTooltip: {
    id: 'field-type.add-field-menu.confluence-link-tooltip',
    defaultMessage: 'Add links to pages or live docs',
    description:
      'Tooltip for the Confluence link field type option in the add field menu.'
  },
  confluenceStatusTooltip: {
    id: 'field-type.add-field-menu.confluence-status-tooltip',
    defaultMessage: 'Display two-way synced status of linked content',
    description:
      'Tooltip for the Confluence status field type option in the add field menu.'
  },
  confluenceLabelTooltip: {
    id: 'field-type.add-field-menu.confluence-label-tooltip',
    defaultMessage: 'Display two-way synced labels on linked content',
    description:
      'Tooltip for the Confluence label field type option in the add field menu.'
  },
  confluenceMoreDetailsTooltip: {
    id: 'field-type.add-field-menu.confluence-more-details-tooltip',
    defaultMessage: 'Display other details of linked content',
    description:
      'Tooltip for the Confluence more details field type option in the add field menu.'
  },
  entryLinkTooltip: {
    id: 'field-type.add-field-menu.entry-link-tooltip',
    defaultMessage: 'Link to an entry in another database',
    description: 'Tooltip for the entry link field type option in the add field menu.'
  },
  entryBacklinkTooltip: {
    id: 'field-type.add-field-menu.entry-backlink-tooltip',
    defaultMessage:
      'Display or count entries in another database that link to this entry',
    description: 'Tooltip for the entry backlink field type option in the add field menu.'
  },
  entryDetailTooltip: {
    id: 'field-type.add-field-menu.entry-detail-tooltip',
    defaultMessage: 'Display details of a linked entry in another database',
    description: 'Tooltip for the entry detail field type option in the add field menu.'
  },
  jiraLinkTooltip: {
    id: 'field-type.add-field-menu.jira-link-tooltip',
    defaultMessage: 'Add links to Jira work items',
    description: 'Tooltip for the Jira link field type option in the add field menu.'
  },
  jiraDetailTooltip: {
    id: 'field-type.add-field-menu.jira-detail-tooltip',
    defaultMessage: 'Displays details of linked Jira work items',
    description: 'Tooltip for the Jira detail field type option in the add field menu.'
  }
});
